import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { ForwardedRef, forwardRef, HTMLProps } from 'react';

export const backgroundImage = ({ icon }: IconDefinition, fill: string, extra: string = '') => {
  return `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' ${extra} viewBox='0 0 ${icon[0]} ${icon[1]}'%3E%3Cpath
    fill='${encodeURIComponent(fill)}' d='${icon[4]}'/%3E%3C/svg%3E"`;
};

const FAIcon = forwardRef(({ icon, ...props }: HTMLProps<HTMLSpanElement> & FontAwesomeIconProps, ref: ForwardedRef<HTMLSpanElement>) => {
  props.className ||= '';
  props.className += ' anticon';
  return <span ref={ref} {...props}><FontAwesomeIcon icon={icon} /></span>;
});

export default FAIcon;
